<template>
  <button
    v-if="experiments['experiment.ppTelcoCalculator'] === 'withCalculator'"
    class="relative mt-12 w-full"
  >
    <div
      class="absolute -top-12 left-24 border-x-12 border-b-12 border-solid border-x-transparent border-b-[#ECEEF2]"
    />
    <div
      class="bg-static-default-mid rounded-lg relative flex items-center gap-8 p-8"
    >
      <slot name="icons" />
      <div class="flex grow items-center justify-between">
        <div>
          <div class="body-2-bold">{{ i18n(translations.title) }}</div>
          <div class="caption">{{ i18n(translations.subtitle) }}</div>
        </div>
        <IconChevronRight />
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import translations from './TelcoCalculatorAdvertisement.translations'

const i18n = useI18n()

const experiments = useExperiments()
</script>
